import * as React from 'react';
const SvgRight = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, fill: "none" }, props),
    React.createElement("path", { fill: "#7C7C7C", fillRule: "evenodd", d: "M7.39 3.762a.6.6 0 0 1 .848.027l4.5 4.8a.6.6 0 0 1 0 .821l-4.5 4.8a.6.6 0 1 1-.875-.82L11.478 9 7.363 4.61a.6.6 0 0 1 .027-.848Z", clipRule: "evenodd" })));
export default SvgRight;
